.main {
  margin-top: 20px;
}

/* Doubled so it outranks antd's own .ant-upload-wrapper .ant-upload-drag rules. */
.dragger.dragger {
  padding: 0 100px 30px 100px;
  border: 2px dashed var(--gray-300);
  border-radius: 12px;
  background-color: var(--surface-container);
  text-align: center;
  cursor: pointer;
}

.dragger.dragger:hover,
.dragger.dragger:global(.ant-upload-drag-hover) {
  border-color: var(--gray-300) !important;
}

.illustration {
  width: 304px;
  height: 226px;
  margin-bottom: 20px;
}

.description {
  margin-bottom: 24px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 400;
}

.fileRow.fileRow {
  width: 100%;
  margin-top: 16px;
  padding: 16px 24px;
  border: 2px solid var(--gray-300);
  border-radius: 12px;
}

.fileName {
  margin-bottom: 0;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
